// extracted by mini-css-extract-plugin
export default {"wrap":"a614453f228b"};